import fetch             from './utils/browser-fetch';
import Errors            from './errors';
import { addError }      from './errors-dux';
import busyActionFactory from './busy';

const initialState = {
    busyFetchingCatalogUrl: false
};


/*******************************************************************************
 * Action types
 */
export const BUSY_FETCHING_CATALOG_URL = 'BUSY_FETCHING_CATALOG_URL';


/*******************************************************************************
 * Reducers
 */
export default function catalogData( state = initialState, action ) {
    switch ( action.type ) {

        case BUSY_FETCHING_CATALOG_URL:
            return {
                ...state,
                busyFetchingCatalogUrl: action.busy
            };

        default:
            return state;
    }
}


/*******************************************************************************
 * Action Creators
 */
const busyFetchingCatalogUrl = busyActionFactory( BUSY_FETCHING_CATALOG_URL );
export function fetchCatalogUrl( type ) {
    return ( dispatch, getState ) => {
        dispatch( busyFetchingCatalogUrl( true ) );

        return fetch( `/api/v1.0/user/catalog-url/${type}`, dispatch )
            .then( ( { catalogUrl } ) => {
                dispatch( busyFetchingCatalogUrl( false ) );
                return catalogUrl;
            } )
            .catch( ( error ) => {
                dispatch( addError( error, Errors.ERROR_SHOP_FETCH_CATALOG_URL ) );
                dispatch( busyFetchingCatalogUrl( false ) );
                throw error;
            } );
    };
}
